<template>
<div>
    <!-- <div class="col-4"> -->
  <ValidationProvider :rules="'required'" v-slot="{ errors }">
    <multiselect v-if="GET_HOTEL_LS"
      v-model="selHotel"
      label="hotelName"
      :allow-empty="false"
      :options="GET_HOTEL_LS"
      :track-by="'hotelid'"
      :showLabels="false"
        :custom-label="getHotelNameId"
      :placeholder="'Change the Hotel'"
      v-on:input="onSelHotel"
    >
 <template slot="singleLabel" ><span class="option__title">{{ 'Change the Hotel'}}</span></template> 
    <template slot="option" slot-scope="props">
      <CRow>
        <CCol>
           <span  class="option__image">
            
             <cHotelThumbnail :imgURL='(props.option.imageBaseurl && props.option.imageUrlLow)?props.option.imageBaseurl+props.option.imageUrlLow:null'>

             </cHotelThumbnail>
           </span>
          </CCol> 
        <CCol>
          <span class="option__title">{{ props.option.hotelName }}</span>
          <span class="option__title">
            <strong>

           
            {{props.option.hotelid}}
             </strong>
          </span>
        </CCol>
        <CCol><span class="option__small">
          <CBadge :color="props.option.isActive  ? 'success' : 'danger'">{{
                    props.option.isActive  ? "Active" : "Inactive"
                  }}</CBadge>
         
          </span>
        </CCol>
      </CRow>
    </template>
      <template #noResult>
        <strong>{{$t('createHotel.listEmpty')}}</strong>
      </template>
    </multiselect>
    <div v-if="errors && errors[0]" class="invalid-feedback icon">
      <span>{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
  </div>
  <!-- </div> -->
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { COMPONENT_NAME } from "../../../../util/constants";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import Logger from '../../../../services/logger';
import { LOG_TYPE } from '../../../../config/API_DATA';
import BaseConfiguration from '../../../../config/base';
import { cloneDeep } from '../../../../util/util';
import cHotelThumbnail from '../../manage/hotelInfo/cHotelThumbnail'
export default {
  name: COMPONENT_NAME.C_HOTEL_SELECTION,
  components: {
    ValidationProvider,
    Multiselect,
    cHotelThumbnail
  },
  props: {
    selValue: {
      type: Object,
      default: null
    },
 },
  data: () => ({
    selHotel: null,
    
  }),
  computed: {
    ...mapGetters("shmsManage", {
      GET_HOTEL_LS: "GET_HOTEL_LS"
    })
  },
  methods:{

    
      getHotelNameId({hotelName,hotelid})
      {


 return `${hotelName} — [${hotelid}]`
      },

      onSelHotel(pHotelObj) {
          try {
            if(BaseConfiguration.isDebug) console.log("onSelHotel");
            
            this.$emit('getSelHotel', cloneDeep( pHotelObj));
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.C_HOTEL_SELECTION,
                    "error in onSelHotel",
                    err.toString(),
                    "onSelHotel",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
           
          }, 
  },
  created() {
      try {
        if(BaseConfiguration.isDebug) console.log("hcreated");
       this.selHotel=this.selValue;
       
       } catch (err) {
              let body = Logger.buildRequest(
                COMPONENT_NAME.C_HOTEL_SELECTION,
                "error in created",
                err.toString(),
                "created",
                LOG_TYPE.ERROR
              );
              Logger.getResponse(body);
            }
        
      }, 
};
</script>